import styled from '@emotion/styled';

export const TranslationCountContainer = styled.div`
    display: flex;
    flex-direction: column;
`;